import ProductTypes from '../enum/ProductTypesEnum';

export type EnabledProductTypes = ProductTypes[];

export interface ProductTypeConfig {
  type: ProductTypes;
  label: string;
}

export const productTypeConfigs: ProductTypeConfig[] = [
  { type: ProductTypes.Stock, label: 'Show Stock Products' },
  { type: ProductTypes.Custom, label: 'Show Custom Products' },
  { type: ProductTypes.Eto, label: 'Show ETO Products' },
];

export const defaultEnabledProductTypes: EnabledProductTypes = [ProductTypes.Stock, ProductTypes.Custom];
